import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';
import { cognitoLoginUrl } from './cognito-login';
import { ExternalNavigation } from './external-navigation.service';

export const adminGuard: CanActivateFn = async (_route, routerState) => {
  const session = inject(AuthSessionService);
  const router = inject(Router);
  const navigation = inject(ExternalNavigation);
  await session.whenReady();
  const state = session.state();
  if (state.status === 'authenticated') {
    return state.principal.roles.includes('admin') ? true : router.createUrlTree(['/ei-oikeutta']);
  }
  navigation.assign(cognitoLoginUrl(routerState.url));
  return false;
};

export function safeReturnUrl(value: string | null | undefined): string {
  return value?.startsWith('/') && !value.startsWith('//') ? value : '/';
}
